import React from "react";
import { TextButton } from "../../design-system/controls";
import { useOpenDocWidget } from "../../hooks";
import "./SetupInstructionsButton.scss";

interface SetupInstructionsButtonIntegration {
  name?: string;
  instructions?: unknown;
}

interface SetupInstructionsButtonProps {
  integration?: SetupInstructionsButtonIntegration;
  forceShow?: boolean;
  "data-testid"?: string;
}

const SetupInstructionsButton: React.FC<SetupInstructionsButtonProps> = ({
  integration,
  forceShow = false,
  "data-testid": dataTestId = "instructions-btn",
}) => {
  const { openWidget } = useOpenDocWidget();

  const showSetupInstructions = !!integration?.instructions || forceShow;

  if (!showSetupInstructions) {
    return null;
  }

  return (
    <TextButton
      wrapperClassName={"instance-setup-instructions-btn-wrap"}
      data-testid={dataTestId}
      type={"button"}
      label={"Setup instructions"}
      buttonStyle={"textLink"}
      data-analytics-event="user_click"
      data-analytics-props={`{"name": "how_to_setup_btn", "integration": "${integration?.name}"}`}
      onClick={() => {
        openWidget();
      }}
    />
  );
};

export default SetupInstructionsButton;
